import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import login2 from "../../assets/login2.gif";
import { useAuth } from "../../context/auth";

const Sign_up = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    contact: "",
    password: "",
    confirmPassword: "",
  });

  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const [auth, setAuth] = useAuth();
  const [showContactPopup, setShowContactPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validatePassword = (password) => {
    const minLength = /.{8,}/;
    const upperCase = /[A-Z]/;
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/;
    const digit = /\d/;

    if (!minLength.test(password)) {
      return "Password must be at least 8 characters long.";
    }
    if (!upperCase.test(password)) {
      return "Password must contain at least one uppercase letter.";
    }
    if (!specialChar.test(password)) {
      return "Password must contain at least one special character.";
    }
    if (!digit.test(password)) {
      return "Password must contain at least one digit.";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const passwordValidationError = validatePassword(formData.password);
    if (passwordValidationError) {
      setPasswordError(passwordValidationError);
      return;
    } else {
      setPasswordError("");
    }

    if (formData.password !== formData.confirmPassword) {
      setConfirmPasswordError("Passwords do not match.");
      return;
    } else {
      setConfirmPasswordError("");
    }

    try {
      const response = await axios.post(
        "https://api.makeeasydocuments.com/api/auth/signup",
        {
          firstname: formData.firstname,
          lastname: formData.lastname,
          email: formData.email,
          password: formData.password,
          contact: formData.contact,
        }
      );

      if (response.status === 201) {
        showCustomToast("Account created successfully..!");

        setTimeout(() => {
          navigate("/sign_in");
        }, 2000);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (error.response.data.message === "User already exists, Please Login") {
          showCustomToast(
            "User already exists. Please try logging in.",
            "error"
          );
          setTimeout(() => {
            navigate("/sign_in");
          }, 2000);
          
        } else {
          showCustomToast(error.response.data.message, "error");
        }
      } else {
        showCustomToast("Signup failed. Please try again.", "error");
      }
    }
  };
  const handleGoogleSuccess = async (response) => {
    if (!response.credential) {
      console.error("Google credential missing");
      showCustomToast("Google login failed: Credential missing", "error");
      return;
    }

    try {
      const res = await fetch("https://api.makeeasydocuments.com/api/auth/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: response.credential }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        const errorMessage =
          errorData.message || "Google authentication failed";
        throw new Error(errorMessage);
      }

      const data = await res.json();
      console.log("Google Auth Response:", data);

      if (data.token) {
        const userId = data.user._id;

        const userWithId = { ...data.user, _id: userId };

        setAuth({ user: userWithId, token: data.token });
        localStorage.setItem(
          "auth",
          JSON.stringify({ user: userWithId, token: data.token })
        );

        const userCheckResponse = await fetch(
          `https://api.makeeasydocuments.com/api/auth/getgoogle/${userId}`
        );
        console.log(userCheckResponse);
        if (!userCheckResponse.ok)
          throw new Error("Failed to fetch user details");

        const userDetails = await userCheckResponse.json();

        if (!userDetails.contact) {
          setShowContactPopup(true);
        } else {
          navigate("/dashboard/allServices");
        }
      } else {
        showCustomToast(data.message || "Google login failed", "error");
      }
    } catch (error) {
      console.error("Google login error:", error);
      showCustomToast(
        error.message || "Something went wrong with Google login!",
        "error"
      );
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };
  useEffect(() => {
    // Load Google API Script
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    let googleInitialized = false;

    script.onload = () => {
      if (window.google && !googleInitialized) {
        googleInitialized = true;
        window.google.accounts.id.initialize({
          client_id:
            "588239284344-osr2rouk6lr9p5p5parmqv11m9pp42b3.apps.googleusercontent.com",
          callback: handleGoogleSuccess,
        });

        const googleButton = document.getElementById("googleSignIn");
        if (googleButton) {
          window.google.accounts.id.renderButton(googleButton, {
            theme: "filled_blue",
            size: "large",
            shape: "rectangular",
          });
        }
      }
    };

    return () => {
      // Clean up script on component unmount
      const loadedScript = document.querySelector(
        'script[src="https://accounts.google.com/gsi/client"]'
      );
      if (loadedScript) {
        document.body.removeChild(loadedScript);
      }
      // Cancel any Google sign-in processes
      if (
        window.google &&
        window.google.accounts &&
        window.google.accounts.id
      ) {
        window.google.accounts.id.cancel();
      }
    };
  }, []); // Empty dependency array to run only once
  return (
    <div>
      <br />
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white !bg-white rounded-lg shadow-2xl lg:max-w-4xl">
        <div
          className="hidden bg-cover lg:block lg:w-1/2 pl-5"
          style={{ backgroundImage: `url(${login2})` }}
        ></div>

        <div className="w-full px-6 py-8 md:px-8 lg:w-1/2">
          <div className="flex justify-center mx-auto">
            <img
              className="h-20 w-30 mr-3"
              src={logo}
              alt="Make Easy Documents Logo"
            />
          </div>

          <p className="mt-3 text-xl text-center text-black">
            Create your account!
          </p>
          {/* Google Sign-In Button */}
          <div
            className="mt-5"
            style={{ height: "15px", width: "380px" }}
          >
            {" "}
            <div
              id="g_id_onload"
              data-client_id="YOUR_GOOGLE_CLIENT_ID"
              data-context="signin"
              data-callback="handleGoogleSuccess"
              data-auto_select="false"
              data-itp_support="true"
            ></div>
            <div className="mt-4">
              <div id="googleSignIn"></div>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mt-6 flex space-x-4">
              {/* First Name */}
              <div className="w-1/2">
                <label
                  className="block mb-2 text-sm font-medium text-black"
                  htmlFor="firstname"
                >
                  First Name
                </label>
                <input
                  id="firstname"
                  name="firstname"
                  className="block w-full px-4 py-2 text-black bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                  type="text"
                  value={formData.firstname}
                  onChange={handleChange}
                />
              </div>

              {/* Last Name */}
              <div className="w-1/2">
                <label
                  className="block mb-2 text-sm font-medium text-black"
                  htmlFor="lastname"
                >
                  Last Name
                </label>
                <input
                  id="lastname"
                  name="lastname"
                  className="block w-full px-4 py-2 text-black bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                  type="text"
                  value={formData.lastname}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mt-4">
              <label
                className="block mb-2 text-sm font-medium text-black"
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                className="block w-full px-4 py-2 text-black bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="mt-4">
              <label
                className="block mb-2 text-sm font-medium text-black"
                htmlFor="contact"
              >
                Contact
              </label>
              <input
                id="contact"
                name="contact"
                className="block w-full px-4 py-2 text-black bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                type="number"
                value={formData.contact}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mt-4 flex space-x-4">
              {/* First Name */}
              <div className="w-1/2">
                <label
                  className="block mb-2 text-sm font-medium text-black"
                  htmlFor="password"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    id="password"
                    name="password"
                    className="block w-full px-4 py-2 text-black bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                    type={passwordVisible ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-2 text-black"
                    onClick={togglePasswordVisibility}
                  >
                    {passwordVisible ? (
                      <AiFillEyeInvisible size={20} />
                    ) : (
                      <AiFillEye size={20} />
                    )}
                  </button>
                </div>
                {passwordError && (
                  <p className="mt-2 text-sm text-red-600">{passwordError}</p>
                )}
              </div>

              <div className="w-1/2">
                <label
                  className="block mb-2 text-sm font-medium text-black"
                  htmlFor="confirmPassword"
                >
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    id="confirmPassword"
                    name="confirmPassword"
                    className="block w-full px-4 py-2 text-black bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                    type={confirmPasswordVisible ? "text" : "password"}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-2 text-black"
                    onClick={toggleConfirmPasswordVisibility}
                  >
                    {confirmPasswordVisible ? (
                      <AiFillEyeInvisible size={20} />
                    ) : (
                      <AiFillEye size={20} />
                    )}
                  </button>
                </div>
                {confirmPasswordError && (
                  <p className="mt-2 text-sm text-red-600">
                    {confirmPasswordError}
                  </p>
                )}
              </div>
            </div>

            <div className="mt-6">
              <button
                type="submit"
                className="w-full px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
              >
                Sign Up
              </button>
            </div>
          </form>

          <div className="flex items-center justify-between mt-4">
            <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>
            <Link
              onClick={() => window.scrollTo(0, 0)}
              to="/sign_in"
              className="text-xs text-gray-500 uppercase dark:text-gray-400 hover:underline"
            >
              or login
            </Link>
            <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>
          </div>
        </div>
      </div>
      <br /> <br />
      <br />
      <Footer />
      <CustomToastContainer />
    </div>
  );
};

export default Sign_up;
